// Gatsby requirements
import React from 'react'

// Components
import RichText from "utils/RichTextRenderer"
import Button from "components/Button/Button"

// Styles
import * as CSS from './SectionCard.module.scss'


const SectionCard = ({ content }) => {

    return (
        <div className={`
            ${CSS.card}
            ${content?.style === 'Pricing' && CSS.pricing}
            ${'card' + content._uid}
            ${content.centerCard ? CSS.centerCard : ''}
        `}>

            {content?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    content.css.replaceAll('.section', '.section' + content._uid).replaceAll('.card', '.card' + content._uid)
                }} />
            }

            <div>
                {content?.price &&
                    <p className={CSS.pricingText}>{content.price} <span>{content?.textAfterPrice}</span></p>
                }

                {content?.richText &&
                    <RichText content={content.richText} />
                }
            </div>

            {content?.button && content.button.map((loop, i) => (
                <Button insertClass="button" data={loop} key={i} />
            ))}
            
        </div>
    )
}

export default SectionCard